import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordWarehouseIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6145 19.8933L15.6146 19.8933C16.2622 20.4275 17.0942 20.75 18 20.75C19.1651 20.75 20.2069 20.2177 20.8933 19.3854L20.8933 19.3854C21.4275 18.7378 21.75 17.9058 21.75 17V14.5773C21.75 13.8437 21.1557 13.2504 20.4227 13.25C20.4225 13.25 20.4222 13.25 20.422 13.25H18C17.0947 13.25 16.2623 13.5716 15.6141 14.107C14.7821 14.7935 14.25 15.8351 14.25 17C14.25 17.9053 14.5716 18.7377 15.107 19.3859C15.2597 19.5709 15.4295 19.7407 15.6145 19.8933ZM18.8513 17.711L18.8512 17.7112C18.6455 17.9608 18.336 18.1179 17.9891 18.1179C17.7186 18.1179 17.4719 18.0227 17.2781 17.8629L17.2773 17.8623C17.2245 17.8189 17.1735 17.7679 17.1254 17.7101C16.966 17.5164 16.8712 17.2706 16.8712 17C16.8712 16.653 17.0283 16.3436 17.2779 16.1379L17.2781 16.1378C17.472 15.9779 17.718 15.8828 17.9891 15.8828C18.6058 15.8828 19.1063 16.3832 19.1063 17C19.1063 17.2705 19.0111 17.5172 18.8513 17.711Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
      />
      <path
        d="M11 22C10.1818 22 9.40019 21.6698 7.83693 21.0095C3.94564 19.3657 2 18.5438 2 17.1613V7M11 22L11 11.3548M11 22C11.7248 22 12.293 21.7409 13.5 21.2226M20 11V7M5 12L7 13M16 4L6 9M4.40472 8.27784L7.32592 9.69138C9.12883 10.5638 10.0303 11 11 11C11.9697 11 12.8712 10.5638 14.6741 9.69138L17.5953 8.27785C19.1984 7.5021 20 7.11423 20 6.5C20 5.88577 19.1984 5.4979 17.5953 4.72215L14.6741 3.30861C12.8712 2.4362 11.9697 2 11 2C10.0303 2 9.12883 2.43621 7.32592 3.30862L4.40472 4.72215C2.80157 5.4979 2 5.88577 2 6.5C2 7.11423 2.80157 7.5021 4.40472 8.27784Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordWarehouseIcon;
